export const projectConstants = {
    GET_SUCCESS: 'GET_PROJECT_SUCCESS',

    ADD_SUCCESS: 'ADD_PROJECT_SUCCESS',
    ADD_FAILURE: 'ADD_PROJECT_FAILURE',

    DELETE_SUCCESS: 'DELETE_PROJECT_SUCCESS',
    DELETE_FAILURE: 'DELETE_PROJECT_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_PROJECT_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_PROJECT_FAILURE',

    CLEAR_ERROR: 'CLEAR_PROJECT_ERROR_CODE'
};
